import React from "react";

export const NotFound: React.FC = () => {
  return <p>Page not found</p>;
};
